(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-customizer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.getElementById('wc-root');
    if (!root) return;

    const totalPriceEl = document.getElementById('totalPrice');
    const addToCartButton = document.querySelector('[data-add-to-cart]');
    const basePrice = Number(root.dataset.basePrice || 0);
    const variantId = root.dataset.variantId || '';

    // 提前解析数据一次（便于调试 & 让外部 JS 可以复用）
    try {
      const datas = JSON.parse(root.dataset.datas || '[]');
      const groups = JSON.parse(root.dataset.groups || '[]');
      const options = JSON.parse(root.dataset.options || '[]');

      console.debug('[watch-customizer] metaobjects loaded', {
        datasLength: datas.length,
        groupsLength: groups.length,
        optionsLength: options.length,
      });

      root.__datas = datas;
      root.__groups = groups;
      root.__options = options;
    } catch (error) {
      console.error('[watch-customizer] Failed to parse metaobject data', error);
    }

    // 初始化基础价格显示（如果你想默认显示基础价）
    if (totalPriceEl) {
      totalPriceEl.textContent = basePrice.toFixed(2);
    }

    // 点击按钮时，优先调用全局 window.addToCart（由大脚本提供）
    async function handleAddToCartProxy() {
      if (!addToCartButton) return;

      // 如果没有挂全局函数，直接返回或给出提示
      if (typeof window.addToCart !== 'function') {
        console.error('[watch-customizer] window.addToCart is not defined');
        // 你也可以在这里 fallback 用 variantId 简单加购：
        // if (variantId) { ... /cart/add.js ... }
        return;
      }

      try {
        addToCartButton.disabled = true;
        await window.addToCart();   // 调用你大脚本里的逻辑（带 sentData）
      } catch (error) {
        console.error('[watch-customizer] Error calling window.addToCart', error);
      } finally {
        addToCartButton.disabled = false;
      }
    }

    if (addToCartButton) {
      addToCartButton.addEventListener('click', handleAddToCartProxy);

      // 如果你希望「即使没有 variantId 也能用自定义组合加购」，这里就不要根据 variantId 禁用按钮
      // 否则，按你原来的逻辑，如果没有 variantId 就禁用：
      // if (!variantId) {
      //   addToCartButton.disabled = true;
      // }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
